import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"380px","width":"400px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title mc",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fw600 fs24 centered",
    style: {"color":"#696969"}
  }, "Zoomアカウントの選択")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = {
  class: "",
  style: {}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "fs14 fw600 mt10 mb10" }, " 会議URLを発行するZoomアカウントを選択できます。選択した順番でZoomアカウントの利用ができるか確認し、使えるアカウントのURLを発行します。 ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "決定", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_ZoomSelectContent = _resolveComponent("ZoomSelectContent")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "ConnectZoomModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll EmailNameFieldsModal",
    onBeforeClose: _ctx.fadeOutModal,
    onBeforeOpen: _ctx.updateZooms
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", {
          class: "ofs centered",
          style: _normalizeStyle(`height: ${_ctx.contentHeight}px;overscroll-behavior: contain;`)
        }, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _hoisted_9,
            _createVNode(_component_ZoomSelectContent, {
              zoomLoctags: _ctx.zoomLoctags,
              sZooms: _ctx.selectedZooms,
              unZooms: _ctx.unselectedZooms,
              onUpdate: _ctx.updateZoomAccounts
            }, null, 8, ["zoomLoctags", "sZooms", "unZooms", "onUpdate"]),
            _hoisted_10
          ])
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("section", {
            id: "roomCloseButton",
            class: "w100 skyblueBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, _hoisted_15)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeClose", "onBeforeOpen"]))
}